<template>
    <div class="page-box-container">

        <!-- Login box -->
        <!-- Login form -->
        <box class="mb-md-30 small-page-box" :padding="60">
            <template v-slot:content>
                <template v-if="!success">
                    <i-logo-color class="i-logo mb-30 d-block d-md-none" />
                    <div class="w-100 text-left fs-20 mb-15 fw-b">{{$t(`${$options.name}.title`)}}</div>
                    <div class="mb-30 text-light ff-l fs-15 fw-n">{{$t(`${$options.name}.description`)}}</div>
                    <el-form @submit="submit()" :error="server_error" :loading="loading" :success="success" :button-text="`${$options.name}.button`">
                        <el-input v-model="user.email" type="email" rule="required|email" name="email" />

                        <template #footerLeft>
                            <router-link class="text-body-light mr-30 my-auto" :to="{ name: 'login' }">{{ $t('general.back') }}</router-link>
                        </template>
                    </el-form>
                </template>
                <template v-else>
                    <div class="w-100 text-left fs-20 mb-30 fw-b text-center">{{$t(`${$options.name}.success_message`)}}</div>
                    <div class="mb-30 text-light ff-l fs-15 fw-n text-center">{{$t(`${$options.name}.success_message_description`)}}</div>
                </template>
            </template>
        </box>

        <!-- Login subtext -->
        <!-- Navigate to register page -->
        <router-link class="text-center text-white small-box-footer d-block" :to="{ name: 'register' }">
            <i18n :path="`${$options.name}.register`">
                <span class="text-white white-hover">{{ $t(`${$options.name}.register_link`) }}</span>
            </i18n>
        </router-link>
    </div>
</template>


<script>
import HasForm from '@/components/forms/has-form';

export default {
    name: "views.guest.forgot",

    components: {
        ElForm: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElForm"),
        ElInput: () => import(/* webpackChunkName: "elements" */ "@/components/forms/ElInput")
    },

    mixins: [HasForm],

    data() {
        return {
            user: {
                email: "",
            }
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$store.dispatch('auth/forgotPassword', this.user)
                .then(() => {
                    this.handleSuccess()
                }).catch(e => this.handleError(e));
    }
}
};
</script>
